<script lang="ts" setup>
  import type { NavLink } from '@layouts/types';

  import { config } from '@layouts/config';
  import { can } from '@layouts/plugins/casl';
  import { getComputedNavLinkToProp, isNavLinkActive } from '@layouts/utils';

  interface Props {
    item: NavLink;
    isSubItem?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    isSubItem: false
  });
</script>

<template>
  <li
    v-if="can(item.action, item.subject)"
    class="nav-link"
    :class="[
      {
        'sub-item': props.isSubItem,
        disabled: item.disable
      }
    ]"
  >
    <Component
      :is="item.to ? 'RouterLink' : 'a'"
      v-bind="getComputedNavLinkToProp(item)"
      :class="{ 'router-link-active router-link-exact-active': isNavLinkActive(item, $router) }"
    >
      <Component
        :is="config.app.iconRenderer || 'div'"
        class="nav-item-icon"
        v-bind="item.icon || config.verticalNav.defaultNavItemIconProps"
      />
      <Component is="span" class="nav-item-title">
        {{ item.title }}
      </Component>
    </Component>
  </li>
</template>

<style lang="scss">
  .layout-horizontal-nav {
    .nav-link a {
      display: flex;
      align-items: center;
    }
  }
</style>
